import ComplyColors from "../components/Constants/constants";

export const sectionStyle = {
  borderRadius: 15,
  width: "100%",
  padding: 20,
  marginLeft: 3,
  marginRight: 3,
  marginBottom: 10,
  backgroundColor: ComplyColors.white,
  boxShadow: "none",
  border: "2px solidrgb(32, 94, 216)",
};

export const labelStyle = {
  display: "block",
  marginBottom: 8,
};

export const inputStyle = {
  width: "100%",
  padding: "0.5rem 0.75rem",
  borderRadius: "0.375rem",
  display: "flex",
  flexDirection: "column",
  fontSize: "13px",
  border: "1px solid #d1d5db",
  boxShadow: "none",
  marginBottom: 12,
  boxSizing: "border-box" as const,
};
export const headerStyle = (value: any): React.CSSProperties => ({
  width: "100%",
  background: ComplyColors.white,
  overflowX: "hidden",
  borderRadius: 6,
  marginBottom: 10,
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box" as const,
});
